import { useNavigate } from 'react-router';

import { Box, Typography, Stack, Grid } from '@mui/material';

import { Issue, IssueStatus } from 'models';
import SortableTable from './SortableTable';
import Icon from 'components/icons/Icon';
import { defaultAppTheme } from 'styles/mui_app_theme/defaultAppTheme';
import RelatedAssetAndComponents from './RelatedAssetAndComponents';
import { ErrorBoundary } from 'react-error-boundary';
import { fullDateAndTimeFromISO } from 'utils/datetime_utils_old';


const IssuesTable =
({
	issues,
	title,
}: {
	issues: Issue[],
	title?: string,
}
) =>
{
	const navigate = useNavigate();
	
	return(
		<Box>
			<Typography
				variant='h6'
			>
				{title}
			</Typography>
			
			<SortableTable
				options={issues}
				onSelect={(selectedOption) => {
					navigate(`/issues/${selectedOption._id}`)
				}}
				rows={[
					{
						title: 'Issue #',
						getCell(issue) {
							return (
								<Box sx={{ marginInline: '0.5rem' }}>
									{issue.issue_num}
								</Box>
							);
						},
					},
					{
						title: 'Status',
						getCell(issue) {
							const { status } = issue;
							return (
								<Stack
									direction='row'
									justifyContent='flex-start'
									alignItems='center'
								>
									<Icon
										of={(status === IssueStatus.OPEN) ? 'open_issue' : 'closed_issue'}
										size='20px'
										color={
											(status === IssueStatus.OPEN)
												? defaultAppTheme.palette.secondary.main
												: defaultAppTheme.palette.success.main
											}
									/>
									
									<Typography
										variant='caption'
										color={
											(status === IssueStatus.OPEN)
											? defaultAppTheme.palette.secondary.main
											: defaultAppTheme.palette.success.main
										}
										sx={{
											paddingLeft: '5px',
										}}
									>
										{ status.toUpperCase() }
									</Typography>
								</Stack>
							)
						},
					},
					{
						title: 'Title',
						getCell(issue) {
							return <Typography
								variant='subtitle1'
								sx={{
									inlineSize: '250px',
									overflowWrap: 'break-word',
								}}
							>
								{ issue.name }
							</Typography>
						},
					},
					{
						title: 'Affected Components',
						getCell(issue) {
							return (
								<Grid
									container
									width='100%'
									sx={{
										marginTop: '5px'
									}}
								>
									<RelatedAssetAndComponents component_ids={issue?.component_ids} />
								</Grid>
							)
						},
					},
					{
						title: 'Date Opened',
						getCell(issue) {
							return (
								<Typography>
									{ fullDateAndTimeFromISO(issue?.date_opened) }
								</Typography>
							)
						}
					}
				]}
			/>
		</Box>
	)
};


export default IssuesTable;